export interface DisplayMetaRow {
  symbol: string;
  nameEn?: string;
  nameZh?: string;
}

// 每行：symbol,name_en,name_zh —— symbol 必填，其余可空；省略的列在后端合并时保留原有值
// （见 hypertrader displayMetaImportMerge 的 COALESCE 语义）。带 BOM/空行/首行表头自动跳过。
//
// 兼容旧的四列格式（symbol,logo_url,name_en,name_zh）：logo_url 列已从后端合并语句中彻底移除，
// 无法再通过导入写入，因此这里按位置识别出 4+ 字段的行并静默丢弃第二列，而不是把它当作 name_en
// 读入 —— 这正是要避免的失败模式。
export function parseDisplayMetaCsv(text: string): { rows: DisplayMetaRow[]; errors: string[] } {
  const rows: DisplayMetaRow[] = [];
  const errors: string[] = [];
  const lines = text.replace(/^\uFEFF/, '').split(/\r?\n/);
  lines.forEach((raw, i) => {
    const line = raw.trim();
    if (!line) return;
    if (i === 0 && /^symbol\s*,/i.test(line)) return; // header
    const fields = line.split(',').map((s) => s.trim());
    // A 4+-field row is a legacy symbol,logo_url,name_en,name_zh paste. logo_url has nowhere to
    // go anymore, so it is dropped by position rather than read as a name.
    const [symbol, nameEn, nameZh] = fields.length >= 4 ? [fields[0], fields[2], fields[3]] : fields;
    if (!symbol) {
      errors.push(`line ${i + 1}: missing symbol`);
      return;
    }
    rows.push({
      symbol,
      ...(nameEn ? { nameEn } : {}),
      ...(nameZh ? { nameZh } : {}),
    });
  });
  return { rows, errors };
}
